import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { EquipmentAlertsSearchSchema } from './-zod-schema';

export const Route = createFileRoute('/_staff/equipment/_layout/alerts/')({
  validateSearch: zodValidator(EquipmentAlertsSearchSchema),
});
